import { paymentOptionsData } from "../../../services/mocks/UtilInfo/data";

export const getPaymentOptions = () => {
  return {
    creditCards: paymentOptionsData?.[0].options?.[0].images,
    pix: paymentOptionsData?.[0]?.options?.[1]?.images?.[0] ?? null,
  };
};
